import { render, staticRenderFns } from "./MelosCarousel.vue?vue&type=template&id=bc6bf71c&scoped=true&"
import script from "./MelosCarousel.vue?vue&type=script&lang=ts&"
export * from "./MelosCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./MelosCarousel.vue?vue&type=style&index=0&id=bc6bf71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6bf71c",
  null
  
)

export default component.exports